import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-lieferart-list-view',
  imports: [],
  templateUrl: './lieferart.list-view.html',
  styleUrls: ['./lieferart.list-view.css'],
})
export class LieferartListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
